import * as React from 'react'

import { styled } from '~/styled'
import type { Override } from '~/utilities/types'

export const StyledText = styled(
  'p',
  {
    base: ['m-0'],
    variants: {
      size: {
        xs: ['text-xs', 'leading-[1.6]', 'capsize-[0.4364]'],
        sm: ['text-sm', 'leading-[1.53]', 'capsize-[0.4056]'],
        md: ['text-md', 'leading-normal', 'capsize-[0.3864]'],
        lg: ['text-lg', 'leading-[1.52]', 'capsize-[0.3983]'],
        xl: ['text-xl', 'leading-[1.42]', 'capsize-[0.3506]'],
        '2xl': ['text-2xl', 'leading-[1.40]', 'capsize-[0.3336]'],
        '3xl': ['text-3xl', 'leading-[1.28]', 'capsize-[0.2709]'],
        '4xl': ['text-4xl', 'leading-none', 'capsize-[0.1309]']
      },
      noCapsize: {
        true: ['capsize-none']
      },
      weight: {
        normal: ['font-normal'],
        bold: ['font-semibold']
      },
      family: {
        body: ['font-body'],
        display: ['font-display'],
        mono: ['font-mono']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

type TextProps = Override<
  React.ComponentProps<typeof StyledText>,
  {
    as?:
      | 'blockquote'
      | 'caption'
      | 'dd'
      | 'dt'
      | 'figcaption'
      | 'li'
      | 'p'
      | 'span'
      | 'legend'
      | React.ComponentType
      | React.ElementType
  }
>

export const Text = React.forwardRef<HTMLParagraphElement, TextProps>(
  ({ size = 'md', family = 'body', ...remainingProps }, ref) => (
    <StyledText size={size} family={family} {...remainingProps} ref={ref} />
  )
)

Text.displayName = 'Text'
